<select-context [context]="SiteContextType.CURRENCY"></select-context>
